import React from "react";
import { useEffect } from "react";
import { ActionTypes } from "./redux/ActionTypes";
import { useDispatch } from "react-redux";
const PageNotFound = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch({ type: ActionTypes.SET_ACTIVE_LINK, payload: null });
    dispatch({ type: ActionTypes.SET_FIRST_LEVEL_ACTIVE_MENU, payload: 0 });
  });
  return (
    <div style={{ textAlign: "center", paddingTop: 20 }}><h1 className="error">404: Page not found</h1></div>
  );
};
export default PageNotFound;